import { useAxios } from "@vueuse/integrations/useAxios";
import http from "@/common/utils/http-common-utils";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";

const FreeSlotServices = {
  fetch: async (clinicId: number, date: string) => {
    const { execute } = useAxios(
      `${ApiRouterConstants.API_SLOTS_FREE}?clinic_id=${clinicId}`,
      { method: "GET", params: { date: date } },
      http,
      {
        immediate: false,
      }
    );
    return await execute();
  },
};

export default FreeSlotServices;
